import resolve from "ioc/resolve";
import modals from "webmodals/modals";
import templateUrl from "emun.on-demand/confirmations/empty-design-confirmation.htm";

class EmptyDesignConfirmationController {
  constructor(options) {
    const $ctrl = this;
    Object.assign($ctrl, options);
    basicController($ctrl);
  }
}

export default {
  open(options) {
    const $q = resolve("$q");
    if (options.design.objects.length) return $q.when(true);
    options.design.validationMessages.push("Empty: Design has no objects");
    let mi = modals.open(
      Object.assign(
        {
          templateUrl,
          resolve: {
            options: () => options
          },
          bindToController: true,
          controller: EmptyDesignConfirmationController,
          controllerAs: "$ctrl"
        },
        options.modal
      )
    );
    return mi.result;
  }
};
